export default __webpack_public_path__ + "static/media/gold.d43fbe38.png";